const formatString = (field: string) => {
  let message = field;
  if (field === '' || field === null || field === undefined) {
    message = '-';
  }
  return message;
};

export default formatString;
